var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmailVector(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 15,
    viewBox: "0 0 19 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.64 4.71381C18.7848 4.59857 19 4.70637 19 4.88853V12.4909C19 13.476 18.2021 14.2753 17.2188 14.2753H1.78125C0.797851 14.2753 0 13.476 0 12.4909V4.89225C0 4.70637 0.211523 4.60228 0.359961 4.71753C1.19121 5.36437 2.29336 6.18595 6.07852 8.94062C6.86152 9.51312 8.18262 10.7176 9.5 10.7102C10.8248 10.7213 12.1719 9.49082 12.9252 8.94062C16.7104 6.18595 17.8088 5.36066 18.64 4.71381ZM9.5 9.51684C10.3609 9.53171 11.6004 8.43132 12.2238 7.97779C17.1482 4.39782 17.523 4.08555 18.6586 3.19335C18.8738 3.02606 19 2.76583 19 2.49074V1.78441C19 0.799266 18.2021 0 17.2188 0H1.78125C0.797851 0 0 0.799266 0 1.78441V2.49074C0 2.76583 0.126172 3.02234 0.341406 3.19335C1.47695 4.08183 1.85176 4.39782 6.77617 7.97779C7.39961 8.43132 8.63906 9.53171 9.5 9.51684Z",
    fill: "#103A50"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailVector);
export default __webpack_public_path__ + "static/media/EmailVector.8afb0cac53cce4d13351f94e42ed2224.svg";
export { ForwardRef as ReactComponent };